import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { BlockTitle } from '../../admin-panel';

import { changeHiddenFromSearchStatus } from 'modules/admin/reducers/admin-profiles';

import { __t, applyTranslations } from 'utils/language';

import type { InfluencerProfile } from 'types';

import './profile-hide-from-search.scss';

applyTranslations(require('./profile-hide-from-search.i18n.json'));

type OwnProps = {
  profile: InfluencerProfile,
  onChange: () => void
}

type DispatchProps = {
  dispatchChangeHiddenFromSearchStatus: (profileId: number, hidden: boolean) => Promise<any>
}

type Props = OwnProps & DispatchProps;

function ProfileHideFromSearch({ profile, onChange, dispatchChangeHiddenFromSearchStatus }: Props) {
  const profileIsHidden = profile.isHiddenFromSearch;

  const handleVisibilitySwitch = async () => {
    await dispatchChangeHiddenFromSearchStatus(profile.id, !profileIsHidden);
    onChange();
  };

  const renderStatus = () => {
    const status = profileIsHidden ? 'hidden' : 'visible';
    const classes = classnames('profile-hide-from-search__status', `profile-hide-from-search__status--${status}`);
    return (
      <span className={classes}>
        {__t(`profile_hide_from_search.status.${status}`)}
      </span>
    );
  };

  const buttonTitle = profileIsHidden ? 'show' : 'hide';

  return (
    <section>
      <BlockTitle>
        {__t('profile_hide_from_search.title')}
        {renderStatus()}
      </BlockTitle>
      <div className="profile-hide-from-search__actions">
        <ActionButton
          className="profile-hide-from-search__button"
          onClick={handleVisibilitySwitch}
        >
          {__t(`profile_hide_from_search.button_title.${buttonTitle}`)}
        </ActionButton>
      </div>
    </section>
  );
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchChangeHiddenFromSearchStatus: (profileId, hidden) => dispatch(changeHiddenFromSearchStatus(profileId, hidden))
});

export default connect(null, mapDispatchToProps)(ProfileHideFromSearch);
